import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import PortalContainer from '../../components/pages/customer-portal/container.jsx';
import ContactsInfo from '../../components/contacts-info.jsx';
import Error from '../../components/feedback/error.jsx';
import Loading from '../../components/feedback/loading.jsx';
import { useQueryActiveCampaign } from '../../hooks/queries/use-active-campaign.jsx';
import { useMediaQuery } from '../../hooks/use-media-query.jsx';

import '../../styles/customer-portal.css';

export default function CustomerPortalIndex() {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery('(min-width: 768px)');

  const queryActiveCampaign = useQueryActiveCampaign();

  useEffect(() => {
    if (queryActiveCampaign.data?.name) {
      navigate(`/portal/${queryActiveCampaign.data.name}`, { replace: true });
    }
  }, [navigate, queryActiveCampaign.data?.name]);

  return (
    <PortalContainer headerUserSection={true}>
      {queryActiveCampaign.isLoading ? (
        <div className="flex h-[70dvh] items-center justify-center">
          <Loading />
        </div>
      ) : queryActiveCampaign.isError ? (
        <Error />
      ) : !queryActiveCampaign.data ? (
        <div className="flex flex-col items-center justify-center">
          <img
            src={
              isDesktop
                ? './assets/no-active-campaign_1920X1080px.png'
                : './assets/no-active-campaign_1080X1920px.png'
            }
            alt="Não existe nenhuma campanha ativa"
            className="rounded-[40px] object-contain"
          />

          <ContactsInfo />
        </div>
      ) : (
        <div className="flex h-[70dvh] items-center justify-center">
          <Loading />
        </div>
      )}
    </PortalContainer>
  );
}
